import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';
import { API } from './constants';
import { useAuth } from '../../contexts/AuthContext';

export const AnnulerPaiementButton = ({ souscriptionId, paiement, getAuthHeader, onDone }) => {
  const { user } = useAuth() || {};
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const pid = paiement.id || String(paiement.numero);
  const isSuperAdmin = (user?.role || '').toLowerCase() === 'super_admin';

  const annuler = async () => {
    setBusy(true);
    try {
      await axios.delete(`${API}/souscriptions/admin/${souscriptionId}/partial-payment/${pid}`, { headers: getAuthHeader() });
      toast.success('Paiement annulé — totaux et reçu mis à jour');
      setOpen(false);
      await onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Échec de l'annulation");
    } finally {
      setBusy(false);
    }
  };

  if (!isSuperAdmin) return null;
  return (
    <>
      <Button size="sm" variant="ghost" onClick={() => setOpen(true)} className="text-red-600 hover:text-red-800"
        title="Annuler ce paiement" data-testid={`annuler-paiement-${pid}`}>
        <Trash2 className="h-4 w-4" />
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="annuler-paiement-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Annuler ce paiement ?</AlertDialogTitle>
            <AlertDialogDescription>
              Le paiement de {(paiement.montant || 0).toFixed(2)} € du {String(paiement.date_paiement || '').slice(0, 10).split('-').reverse().join('/')} sera retiré de l'historique.
              Le montant payé et le reste dû seront recalculés et le reçu refait (sans prévenir le membre).
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="annuler-paiement-non">Non</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); annuler(); }} disabled={busy}
              className="bg-red-600 hover:bg-red-700" data-testid="annuler-paiement-confirmer">
              {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Oui, annuler le paiement
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
